<form>
  <mat-form-field class="full-width">
    <mat-label translate>Choose Parameter</mat-label>
    <input type="text" matInput [formControl]="searchText" [matAutocomplete]="auto">
    @if (selectedItem?.isTooManyValues) {
      <mat-icon matTextSuffix class="input-warn-icon"
        [matTooltip]="tooManyValuesTooltip" matTooltipPosition="above">
      warning_amber</mat-icon>
    }

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="dispalyName"
      (optionSelected)="onItemSelected($event.option.value)" (closed)="onPanelClosed()">
      @for (group of ruleFieldGrouped; track group.group) {
        <mat-optgroup>
          <mat-label translate>{{predicateGroupNameByValue(group.group)}}</mat-label>
          @for (rule of group.fields; track rule) {
            <mat-option #opt #tooltip="matTooltip" [value]="rule"
              [disabled]="group.hidden" [matTooltip]="rule.description">
              <span translate>{{rule.name}}</span><br />
              @if (rule.description && !opt.selected) {
                <span class='predicate-description'
                translate>[{{rule.description}}]</span>
              }
            </mat-option>
          }
        </mat-optgroup>
      }
      @if (ruleFieldGrouped.length === 0) {
        <mat-option disabled translate>
          No fields found
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>